<template>
  <main :class="['wrapper', state]">
    <header class="header">
      <div class="header__actions">
        <router-link to="/settings">
          <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.4153 22.4789C14.684 23.7183 16.2123 24.338 18 24.338C19.7877 24.338 21.316 23.7183 22.5847 22.4789C23.8534 21.2394 24.4878 19.7465 24.4878 18C24.4878 16.2535 23.8534 14.7606 22.5847 13.5211C21.316 12.2817 19.7877 11.662 18 11.662C16.2123 11.662 14.684 12.2817 13.4153 13.5211C12.1466 14.7606 11.5122 16.2535 11.5122 18C11.5122 19.7465 12.1466 21.2394 13.4153 22.4789ZM31.7541 19.7746L35.6468 22.7324C36.0505 23.0141 36.1081 23.4085 35.8198 23.9155L32.1001 30.169C31.8694 30.5634 31.4946 30.6761 30.9756 30.507L26.3909 28.7324C25.1798 29.5775 24.1418 30.169 23.2767 30.507L22.5847 35.2394C22.4694 35.7465 22.181 36 21.7197 36H14.2803C13.819 36 13.5306 35.7465 13.4153 35.2394L12.7233 30.507C11.6276 30.0563 10.5895 29.4648 9.60913 28.7324L5.02443 30.507C4.50541 30.6761 4.13056 30.5634 3.89988 30.169L0.180216 23.9155C-0.10813 23.4085 -0.0504606 23.0141 0.353224 22.7324L4.24589 19.7746C4.18823 19.3803 4.15939 18.7887 4.15939 18C4.15939 17.2113 4.18823 16.6197 4.24589 16.2254L0.353224 13.2676C-0.0504606 12.9859 -0.10813 12.5915 0.180216 12.0845L3.89988 5.83099C4.13056 5.43662 4.50541 5.32394 5.02443 5.49296L9.60913 7.26761C10.8202 6.42254 11.8582 5.83099 12.7233 5.49296L13.4153 0.760563C13.5306 0.253521 13.819 0 14.2803 0H21.7197C22.181 0 22.4694 0.253521 22.5847 0.760563L23.2767 5.49296C24.3724 5.94366 25.4105 6.53521 26.3909 7.26761L30.9756 5.49296C31.4946 5.32394 31.8694 5.43662 32.1001 5.83099L35.8198 12.0845C36.1081 12.5915 36.0505 12.9859 35.6468 13.2676L31.7541 16.2254C31.8118 16.6197 31.8406 17.2113 31.8406 18C31.8406 18.7887 31.8118 19.3803 31.7541 19.7746Z"/>
          </svg>
        </router-link>
      </div>
      <div class="header__logo">
        <img :src="config.logo"/>
      </div>
    </header>

    <div class="scanner">
      <div class="scanner__text">
        {{ stateText }}
      </div>

      <Camera @init="onCameraInit" @detect="onDetect" @error="onError" v-if="scannerSettings.scanMode === 'camera'"/>
      <HandheldScanner v-else-if="scannerSettings.scanMode === 'handheld'" @focus="handheldFocus"
                       @blur="handheldBlur"
                       @detect="onDetect"
                       :state="state"/>

      <Result v-if="state === 'scanSuccess' && scanResult" :result="scanResult"/>

      <div class="error" v-if="error||offline">
        <div class="error__modal" v-if="error">{{ error }}</div>
        <div class="error__modal error__modal_offline" v-else-if="offline">Нет подключения к интернету. Пожалуйста,
          убедитесь, что вы подключены к сети.
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Camera from '../components/CameraNew';
// import Result from '../components/Result';
import config from '/src/scanner.config';
import Result from '../components/Result';
import HandheldScanner from '../components/HandheldScanner';

const sounds = {
  success: require('@/assets/sound/scan-success.mp3'),
  fail: require('@/assets/sound/scan-fail.mp3')
}

export default {
  name: 'Scanner',
  components: {HandheldScanner, Result, Camera},
  data() {
    return {
      state: 'idle',
      scanResult: null,
      loading: false,
      error: null,
      offline: false,
      domain: null,
      stateResetTimeout: null
    }
  },
  methods: {
    onCameraInit(result) {
      if (result?.error)
        if (result.error.name === 'NotAllowedError') {
          this.error = 'Без доступа к камере приложение не может работать. Пожалуйста, разрешите доступ к камере в настройках сайта и обновите страницу.'
        } else {
          this.error = 'Не удалось подключиться к камере. Попробуйте открыть сайт в другом браузере.'
        }
    },
    onDetect(result) {
      this.state = 'loading'
      fetch(`https://api.checkqr.ru/api/v1/check/?url=${result}`).then(r => r.json()).then(r => {
        this.loading = false
        this.domain = r.domain
        if (r.valid) {
          this.scanResult = r.data
          this.state = 'scanSuccess'
          this.playSound('success')
        } else {
          this.playSound('fail')
          this.scanResult = null
          if (r.fraud) {
            this.state = 'scanFail_fraud'
          } else if (r.message === 'wrong url') {
            this.state = 'scanFail_domain'
          } else {
            this.state = 'scanFail'
          }
        }
      }).catch(() => {
        this.loading = false;
        this.onError()
      })
    },
    onError() {
      clearTimeout(this.stateResetTimeout)
      this.scanResult = null
      this.state = 'scanError'
      this.playSound('fail')
      this.stateResetTimeout = setTimeout(() => {
        this.state = 'idle'
      }, 3000)
    },
    formatDate(date) {
      const d = new Date(date);
      const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()} года`
    },
    playSound(type) {
      if (this.$store.state.scannerSettings.sound) {
        if (type === 'success') {
          const sound = new Audio(sounds.success)
          sound.play()
        } else if (type === 'fail') {
          const sound = new Audio(sounds.fail)
          sound.play()
        }
      }
    },
    handheldFocus() {
      // if (this.state === 'idleHandheld_notFocused')
      this.state = 'idleHandheld'
    },
    handheldBlur() {
      // if (this.state === 'idleHandheld')
      this.state = 'idleHandheld_notFocused'
    }
  },
  computed: {
    config() {
      return config
    },
    scannerSettings() {
      return this.$store.state.scannerSettings
    },
    stateText() {
      return config.strings[this.state]
    }
  },
  watch: {
    state(val) {
      this.$root.$el.dataset.scannerState = val
    }
  },
  mounted() {
    if (this.scannerSettings.scanMode === 'camera') this.state = 'idleCamera'
    else if (this.scannerSettings.scanMode === 'handheld') this.state = 'idleHandheld_notFocused'

    if (!window.navigator.onLine) this.offline = true;

    addEventListener('offline', () => {
      this.offline = true
    })
    addEventListener('online', () => {
      this.offline = false
    })
  },
  beforeDestroy() {
    this.$root.$el.dataset.scannerState = null
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  padding: 2rem;
  min-height: 100vh;
  text-align: center;
  background-color: var(--bg);

  --bg: var(--bg);
  --text: var(--text);

  &.scanSuccess {
    --bg: var(--bg-success);
    --text: var(--text-success);
  }

  &[class*='scanFail'], &.scanError {
    --bg: var(--bg-fail);
    --text: var(--text-fail);
  }
}

.header {
  width: 100%;
  margin-bottom: 3rem;

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;

    svg {
      display: block;
      width: 20px;
      height: 20px;
      fill: currentColor;
    }
  }

  &__logo {
    margin-top: 1rem;

    img {
      display: block;
      margin: auto;
      max-height: 60px;
      width: 100%;
    }
  }
}

.scanner {
  max-width: 800px;
  margin: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;

  &__text {
    font-weight: 700;
    font-size: 17px;
    color: var(--text);
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.error {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;

  &__modal {
    background: white;
    padding: 20px;
    line-height: 1.5;
    border-radius: 8px;
    width: calc(100% - 40px);
    max-width: 800px;

    &::before {
      content: url("data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.3691 22.4688C17.892 22.4688 22.3691 17.9916 22.3691 12.4688C22.3691 6.9459 17.892 2.46875 12.3691 2.46875C6.84629 2.46875 2.36914 6.9459 2.36914 12.4688C2.36914 17.9916 6.84629 22.4688 12.3691 22.4688Z' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.3691 8.46875V12.4688' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.3691 16.4688H12.3791' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      display: block;
    }

    &_offline::before {
      content: url("data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M1.24219 1.30859L23.2422 23.3086' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M16.9629 11.3672C17.782 11.7669 18.5479 12.2675 19.2429 12.8572' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M5.24219 12.8588C6.72427 11.6196 8.50806 10.795 10.4122 10.4688' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.9531 5.36029C13.0955 5.18765 15.2508 5.44845 17.2902 6.12711C19.3296 6.80576 21.2113 7.88836 22.8231 9.31029' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1.66211 9.30969C3.04927 8.08354 4.63981 7.10891 6.36211 6.42969' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M8.77148 16.4173C9.78669 15.6961 11.0012 15.3086 12.2465 15.3086C13.4918 15.3086 14.7063 15.6961 15.7215 16.4173' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.2422 20.3086H12.2522' stroke='%23EE6C6C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='24' height='24' fill='white' transform='translate(0.242188 0.308594)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    }
  }
}
</style>
